import React, { useState, useEffect, useRef } from "react";
import { View, Text, TouchableOpacity } from "react-native";
import moment from "moment";
import CustomButton from "../../common/CustomButton";
import "react-datepicker/dist/react-datepicker.css";
import { downloadStatement,downloadStatementHistory,getStatementDownLoadStatus,downloadStatementHistoryExcel, getStatements} from "../../api/statementApi";
import useStyles from "../../screens/Statement_Styles";
import CText from "../../common/CText";
import CImage from "../../common/CImage";
import { COLORS } from "../../constant";
import { ModalAlertSuccess, StatementAlert, StatementAlertSendEmail, StatementNoPreviewAlert } from "../../screens/StatementAlert.web";
import Timer, { DownloadTimer } from "./TimerLoader";
import Loader from "../../common/Loader.web";


const StatementHelpler = (props) => {
  let interval = useRef();
  let count = 0
  const fromDate = props?.fromDate 
  const toDate = props?.toDate 
  const selectedItem = props?.selectedItem
  const poolAcntNbr = props?.poolAcntNbr
  const setAlertModalVisible = props?.setAlertModalVisible
  const setAlertModal = props?.setAlertModal
  const setLoading = props?.setLoading
  const fetchRecords = props?.fetchRecords
  const setFilterModalVisible = props?.setFilterModalVisible
  const filterSetSelectStatementType =props?.filterSetSelectStatementType
  const filterSetSelectStatementDownloadType=props?.filterSetSelectStatementDownloadType
  const filterSelectStatementDownloadType=props?.filterSelectStatementDownloadType
  const filterStatementType = props?.filterStatementType
  const transactionType = props?.transactionType
  const setTransactionType = props?.setTransactionType
  const vehicleLength = props?.vehicleLength
  const period = props?.period
  const minAmount = props?.minAmount
  const maxAmount = props?.maxAmount
  const setShowLoader = props?.setShowLoader
  const styles = useStyles();
  const [isInterval, setIsInterval] = useState(false);
  const [showPdf ,setShowPdf] = useState(true)
  const [history , setHistory] = useState(0)
  const retryCount = 15
  const checkInterval = 60000
  const [showAlert, setShowAlert] = useState(false);
  const [showAlertGetMail, setShowAlertGetMail] = useState(false);
  const [showAlertNoPreview, setShowAlertNoPreview] = useState(false);
  const [emailToSend, setEmailToSend] = useState(null);
  const [isGenerating, setIsGenerating] = useState(false);
  const [emailParams, setEmailParams] = useState(null); 

  const handleConfirmEmail = (email) => {
    setEmailToSend(email);
    onDownloadStatementAction("Email", email); // pass email as param
  };
  
  const handleEmailClick = async () => {
    setLoading(true);
  
    // Skip API call for VEHICLE_SUMMARY or VEHICLE_CONSOLIDATED
    if (selectedItem === "VEHICLE_SUMMARY" || selectedItem === "VEHICLE_CONSOLIDATED") {
      setShowAlert(true);
      setLoading(false);
      setAlertModalVisible(false);
      return; // 👈 Exit early
    }
  
    const params = {
      userId: global.userCd,
      vrn:
        selectedItem === poolAcntNbr || selectedItem === "Consolidated"
          ? ""
          : selectedItem,
      statementType:
        filterStatementType === "Debit"
          ? "D"
          : filterStatementType === "Credit"
          ? "C"
          : "Both",
      periodOfStmt: toDate === "" || fromDate === "" ? period : "custom",
      poolAccountNo: selectedItem === poolAcntNbr ? poolAcntNbr : "",
      customFrom: fromDate ? moment(fromDate).format("YYYY-MM-DD") : "",
      customTo: toDate ? moment(toDate).format("YYYY-MM-DD") : "",
      priceFrom: minAmount,
      priceTo: maxAmount,
      pageNo: "0",
      transactionType: transactionType,
    };
  
    try {
      const res = await getStatements(params);
      const data = res.transactions;
  
      if (!data || data.length === 0) {
        setAlertModal({
          title: "",
          status: "Failed",
          message: "No transactions for the selected period",
          navigateScreen: "Statement",
          actionButton: "OK",
        });
        setAlertModalVisible(true);
      } else {
        setShowAlert(true); // Only show alert if data is present
      }
    } catch (err) {
      setAlertModal({
        title: "Error",
        status: "error",
        message: err?.message || "Something went wrong.",
        navigateScreen: "",
        actionButton: "OK",
      });
      setAlertModalVisible(true);
    } finally {
      setLoading(false);
    }
  };
  
  
  // let showPdf = true

  // if(selectedItem == poolAcntNbr || selectedItem == "Consolidated" || selectedItem == "" ){
  //   if(vehicleLength > global.MAX_VRN_COUNT_PORTAL_STMT){setShowPdf(false)}}

  const disablePdf =
  selectedItem === "VEHICLE_SUMMARY" || selectedItem === "VEHICLE_CONSOLIDATED";
  const onDownloadStatementAction = (actionType = "Download", email = null) => {
  const downloadType = filterSelectStatementDownloadType; // "PDF" or "CSV"      
  const apiType = actionType === "Email" ? "email" : "download";

const params = {
  userId: global.userCd,
  vrn:
    selectedItem === poolAcntNbr ||
    selectedItem === "Consolidated" ||
    selectedItem === "VEHICLE_SUMMARY" ||
    selectedItem === "VEHICLE_CONSOLIDATED"
      ? ""
      : selectedItem,

  statementType:
      selectedItem === "VEHICLE_SUMMARY" || selectedItem === "VEHICLE_CONSOLIDATED"
      ? selectedItem
      : selectedItem == poolAcntNbr
      ? "POOL"
      : selectedItem == "Consolidated"
      ? "CONSOLIDATED"
      : selectedItem && selectedItem !== poolAcntNbr && selectedItem !== "VEHICLE_SUMMARY" && selectedItem !== "VEHICLE_CONSOLIDATED" && selectedItem !== "Consolidated"
      ? "VEHICLE"
      : "CONSOLIDATED",

  periodOfStmt: fromDate ? "custom" : `${period}`,
  poolAccountNo: selectedItem === poolAcntNbr ? poolAcntNbr : "",
  customFrom: fromDate ? moment(fromDate).format("YYYY-MM-DD") : "",
  customTo: toDate ? moment(toDate).format("YYYY-MM-DD") : "",
  priceFrom: minAmount,
  priceTo: maxAmount,
  pageNo: "0",
  transactionType: transactionType,
  type: apiType,
  downLoadType: selectedItem === "VEHICLE_SUMMARY" || selectedItem === "VEHICLE_CONSOLIDATED"? "CSV" : downloadType,
};


  if (email && apiType === "email") {
    params["emailId"] = email;
  }

  // setLoading(true);
  setIsGenerating(true); // 👈 Starts Timer UI


  downloadStatement(params)
    .then((res) => {
      if (res.statusCode === 750) {
        // 👇 show modal and store current params
        setIsGenerating(false);
        setEmailParams(params);
        setShowAlertGetMail(true);
        
        return;
      }
      if (apiType === "download") {
  const downloadUrl = res?.data?.encodedStmttFile;
  const fileExt = res?.data?.downLoadType === "PDF" ? ".pdf" : ".zip";
  const timestamp = moment(new Date()).format("DD-MM-YYYY_hh-mm-ssa");
  const fileName = `Statement_${timestamp}${fileExt}`;

  if (downloadUrl) {
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  setIsGenerating(false);
}

      if (res.statusCode === 700 ) {
        setAlertModal({
          title: "Successful",
          status: "success",
          message: res.message,
          navigateScreen: "Statement",
          actionButton: "OK",
        });
      } 
      else if (res.statusCode === 404) {
        setAlertModal({
          title: "Error",
          status: "Failed",
          message: res.message || "No transactions for the selected period",
          navigateScreen: "Statement",
          actionButton: "OK",
        });
      }
     else {
        setAlertModal({
          title: "Error",
          status: "error",
          message: res.message,
          navigateScreen: "",
          actionButton: "OK",
        });
        
      }
    })
    .catch((err) => {
      setAlertModal({
        title: "Error",
        status: "error",
        message: err?.message,
        navigateScreen: "",
        actionButton: "OK",
      });
      setIsGenerating(false); // 👈 Stop Timer UI`
    })
    .finally(() => {
      // setLoading(false);
      setIsGenerating(false)
      setAlertModalVisible(true);
    });
};











  const cickedButton = (text) => {
    return (
      <TouchableOpacity onPress={() => removeFilter(text)}>
        <View style={styles.clickedBtnStyle}>
          <CText.tagWarningText>{text}</CText.tagWarningText>
          <View style={{ marginTop: 10 }}>  <CImage.close /></View>
        </View>
      </TouchableOpacity>
    )
  }
  const removeFilter = (param) => {
   setTransactionType("")
  }
  useEffect(()=>{
    fetchRecords("0")
  },[transactionType,filterStatementType])

  return (
    
    
    <>
    {isGenerating && <Loader/>}
    {/* // <View style={styles.containerTimer}>
    //   <View style={styles.overlayTimer}>
    //     <View style={styles.loaderBgTimer}>
    //      <View style={styles.spinnerBox}>
    //         <DownloadTimer duration={60000} />
    //         <View style={{marginTop:20}}/>
    //         <CText.basicInformation>{"Generating Statement"}</CText.basicInformation>
    //         <CText.otpDesc style={{fontSize: 11}}>
    //           {"Please do not navigate away from this page. The statement will be downloaded soon."}
    //         </CText.otpDesc>
    //       </View>
    //     </View>
    //   </View>
    //  </View> */}



      <View style={styles.buttonsWrapper}>

        <TouchableOpacity onPress={() => setFilterModalVisible(true)}>
          <View style={styles.filterButtonWrapper}>
            <CText.serviceDesc>FILTER</CText.serviceDesc>
            <View>
              <CImage.filterUpArrow />
              <CImage.filterDownArrow />
            </View>   </View>
        </TouchableOpacity>

      <View style={styles.filterWrapper}>

    
        <View >
          {transactionType == "fuel" ?
            cickedButton("FUEL PAYMENT") :
            <CustomButton onPress={() => setTransactionType("fuel")} text={"FUEL PAYMENT"} disable={false} style={styles.btnStyle} />}
        </View>
        <View >
          {transactionType == "toll" ?
            cickedButton("TOLL PAYMENT") :
            <CustomButton onPress={() => setTransactionType("toll")} text={"TOLL PAYMENT"} disable={false} style={styles.btnStyle} />}
        </View>
        {/* <View >
          {transactionType == "parking" ?
            cickedButton("PARKING") :
            <CustomButton onPress={() => setTransactionType("parking")} text={"PARKING"} disable={false} style={styles.btnStyle} />}
        </View> */}
        </View>

        <View style={styles.creditwrapperd}>
          {filterStatementType == "Both" ?<Text style ={styles.activeFilter}>{"ALL"}</Text>:
            <TouchableOpacity onPress={()=>{filterSetSelectStatementType("Both")}}> <CText.tagWarningText >{"    ALL"}</CText.tagWarningText></TouchableOpacity>
           }

          {filterStatementType == "Credit" ?<Text style ={styles.activeFilter}>{"CREDIT"}</Text>:
            <TouchableOpacity onPress={()=>{filterSetSelectStatementType("Credit")}}> <CText.tagWarningText >{"CREDIT"}</CText.tagWarningText></TouchableOpacity>
           }
           {filterStatementType == "Debit" ?<Text style ={[styles.activeFilter,{width:120}]}>{"DEBIT"}</Text>:
            <TouchableOpacity onPress={()=>{filterSetSelectStatementType("Debit")}}> <CText.tagWarningText >{"DEBIT"}</CText.tagWarningText></TouchableOpacity>
           }
        </View>
       
        <View style={styles.downloadBtnWrapper}>
          <View style={{ ...styles.creditwrapper, width: 100, height: 23, gap: 15, marginLeft: -5 }}>
          {disablePdf ? (
              <Text style={[styles.inactiveDownloadFilter, { fontSize: 11 }]}>{"PDF"}</Text>
            ) : filterSelectStatementDownloadType === "PDF" ? (
              <Text style={styles.activeDownloadFilter}>{"PDF"}</Text>
            ) : (
              <TouchableOpacity onPress={() => filterSetSelectStatementDownloadType("PDF")}>
                <CText.tagWarningText style={{ fontSize: 10, marginLeft: 5 }}>{"    PDF"}</CText.tagWarningText>
              </TouchableOpacity>
            )}

            {filterSelectStatementDownloadType === "CSV" ? (
              <Text style={styles.activeDownloadFilter}>{"CSV"}</Text>
            ) : (
              <TouchableOpacity onPress={() => filterSetSelectStatementDownloadType("CSV")}>
                <CText.tagWarningText style={{ fontSize: 11, marginRight: 5 }}>{"CSV    "}</CText.tagWarningText>
              </TouchableOpacity>
            )}
          </View>

          
              <View style={styles.verticalLineDownload}></View>
              <TouchableOpacity onPress={() => onDownloadStatementAction("Download")}>
                <CText.tagWarningText style={{ fontSize: 11, color: COLORS.blue }}>{"Download"}</CText.tagWarningText>
              </TouchableOpacity>
         

          <View style={styles.verticalLineDownload}></View>
          <TouchableOpacity onPress={handleEmailClick}>
            <CText.tagWarningText style={{ fontSize: 11, color: COLORS.blue }}>{"Email"}</CText.tagWarningText>
          </TouchableOpacity>

          <StatementAlert
                open={showAlert}
                onClose={() => setShowAlert(false)}
                onConfirm={(email) => { handleConfirmEmail(email); setShowAlert(false); }}
            />
            <StatementAlertSendEmail
                open={showAlertGetMail}
                onClose={() => setShowAlertGetMail(false)}
                onSend={(email) => { handleConfirmEmail(email); setShowAlertGetMail(false); }}
              />
          </View>
          

        {/* <CImage.pdf />
        <CImage.xls /> */}
        
      </View>   

   
    </>
  );
};
export default StatementHelpler;


